export function uetReportConversion() {
  window.uetq = window.uetq || [];
  window.uetq.push('event', 'signup', {});
}
